<template>
  <div class="dt-progress-bar-container" style="position: relative">
    <div
      class="dt-progress-bar"
      :style="{
        width: `${finalValue}%`,
        transition: `${duration || 200}ms width ease-out`,
      }"
    ></div>
    <div
      style="margin-top: 16px; width: 100%; position: absolute"
      class="ut-text-secondary ut-flex ut-jbetween ut-fw"
    >
      <div class="upload-speed">
        <span>{{ formatBytes(uploadSpeed) }}/s</span>
      </div>
      <div class="remaining-time">
        <span>{{ remainingTimeInMinSec }} {{ $t("remaining") }} </span>
      </div>
    </div>
  </div>
</template>
<script>
import { padWithZero } from "../../utility/calendar";
const STEP = 20;

export default {
  props: {
    value: {
      type: Number,
    },
    remainingTimeInMinSec: {
      type: String,
    },
    uploadSpeed: {
      type: Number,
    },
    animate: {
      type: Object,
    },
    duration: {
      type: Number,
    },
  },
  data() {
    return { val: 0, animateInterval: null };
  },
  computed: {
    finalValue() {
      if (this.val > 0) {
        return this.val;
      } else {
        return this.value;
      }
    },
//     hint() {
//       return `Upload Speed: ${this.formatBytes(this.uploadSpeed) + "/s"}
// Remaining Time: ${this.remainingTimeInMinSecPrecise}
// `;
//     },
    // remainingTimeInMinSec() {
    //   let hours = Math.floor((this.remainingTime || 0) / 3600) || 0;

    //   // console.log({'progress-bar.vue:64 this.remainingTime' : this.remainingTime});
    //   // console.log({'progress-bar.vue:64 Math.floor((this.remainingTime || 0) / 3600)' : Math.floor((this.remainingTime || 0) / 3600)});

    //   let minutes =
    //     Math.floor(((this.remainingTime || 0) - hours * 3600) / 60) || 0;
    //   let seconds =
    //     (this.remainingTime || 0) - hours * 3600 - minutes * 60 || 0;
    //   // If Hour is 0, then show only minutes and seconds
    //   hours = hours > 0 ? Math.floor(hours) : 0;
    //   minutes = minutes > 0 ? Math.floor(minutes) : 0;
    //   seconds = seconds > 0 ? Math.floor(seconds) : 0;

    //   if (hours === 0) {
    //     if (minutes === 0) {
    //       return `${seconds} Seconds`;
    //     } else {
    //       return `${this.$t("about")} ${minutes} Minutes`;
    //     }
    //   } else {
    //     return `${this.$t("about")} ${hours} Hours ${minutes} Minutes`;
    //   }
    // },
    // remainingTimeInMinSecPrecise() {
    //   let hours = Math.floor(this.remainingTime / 3600);
    //   let minutes = Math.floor((this.remainingTime - hours * 3600) / 60);
    //   const seconds = this.remainingTime - hours * 3600 - minutes * 60;
    //   // If Hour is 0, then show only minutes and seconds
    //   if (hours === 0) {
    //     if (minutes === 0) {
    //       return `${padWithZero(seconds)} Seconds`;
    //     } else {
    //       return `${padWithZero(minutes)}:${padWithZero(seconds)}`;
    //     }
    //   } else {
    //     return `${padWithZero(hours)}:${padWithZero(minutes)}:${padWithZero(
    //       seconds
    //     )}`;
    //   }
    // },
  },
  mounted() {
    if (this.animate) {
      this.val = this.animate?.from > 1 ? this.animate?.from : 1;

      setTimeout(() => {
        this.val = this.animate?.to || 100;
      }, 10);
      // console.log({ "this.animate": this.animate });
      // const widthStep = (this.animate?.to - this.animate?.from) / STEP;
      // console.log({ "this.animate?.to": this.animate?.to });
      // console.log({ "this.animate?.from": this.animate?.from });
      // console.log({ widthStep: widthStep, STEP });
      // this.animateInterval = setInterval(() => {
      //   this.val += widthStep;
      //   console.log({ "this.val": this.val });
      // }, this.animate?.duration / STEP);

      // setTimeout(() => {
      //   clearInterval(this.animateInterval);
      // }, this.animate?.duration);
    }
  },
  methods: {
    formatBytes(bytes) {
      if (bytes < 1024) return bytes + " B";
      else if (bytes < 1048576) return (bytes / 1024).toFixed(2) + " KB";
      else if (bytes < 1073741824) return (bytes / 1048576).toFixed(2) + " MB";
      else return (bytes / 1073741824).toFixed(2) + " GB";
    },
  },
};
</script>
<style lang="scss">
.dt-progress-bar-container {
  width: 100%;
  height: 8px;
  display: flex;
  border-radius: 8px;
  border: 1px solid var(--sprt-8);
  .dt-progress-bar {
    background: var(--sprt-85);
    border-radius: 8px;
  }
}
</style>